import { Block } from '../../../block/block.component';
import { templates } from './belly.constants';
import { START_POINT_MODE_CENTER } from '../../../row/row.constants';
import { List } from '../list/list.component';

export default class Belly extends List {
  static _template() {
    return {
      Block: {
        type: Block,
        startPointMode: START_POINT_MODE_CENTER,
      },
    };
  }
}

Belly.Templates = templates;
